export const TypeEnum = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal',
};
export const AnimationTypeEnum = {
  SCALEUP: 'scaleUp',
  SCALEDOWN: 'scaleDown',
};
